export { default } from "./PrivacyPage";
